import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMainBrokerageTrackingControlPanel extends Layout {
    automateTrackingPanel: Panel;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelA: Label;
    sourceBrTrackingCtrl: DataSource;
    switchAutoSend: Switch;
    switchAutomateArrivalsandDepartures: Switch;
    switchAutomateTrackingInitiation: Switch;
    switchIsDefault: Switch;
    switchRequireTracking: Switch;
    textboxHoursPrior: Textbox;
    textboxInboundMessageOption: Textbox;
    textboxOutboundMessageOption: Textbox;
    textboxTrackingBrokerageStatus: Textbox;
    textboxTrackingRateConf: Textbox;
}
